import * as React from "react";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {RNTextInput} from "shared/controls/SingleInputs/RNTextInput";
import {observer} from "mobx-react";
import {BackgroundStyleEnum, PageTypeEnum, PDFDocumentOptions} from "PageBuilder/pagebuilder/PDFDocument.Options";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";
import {PageService} from "PageBuilder/pagebuilder/services/PageService";
import {PDFDocument} from "PageBuilder/pagebuilder/PDFDocument";
import {RNCheckBox} from "shared/controls/SingleInputs/RNCheckBox/RNCheckBox";
import {Tabs} from "shared/controls/Tabs/Tabs";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faCog} from "@fortawesome/free-solid-svg-icons/faCog";
import {faPalette} from "@fortawesome/free-solid-svg-icons/faPalette";
import {IObservableValue, observable} from "mobx";
import {StyleClassManager, StyleManager} from "InternalShared/PageBuilder/Controls/Core/styles/StyleManager";
import {RNColor} from "shared/controls/SingleInputs/RNColor/RNColor";
import {FontUploader} from "InternalShared/Dialog/FileUploader";
import {faTrash} from "@fortawesome/free-solid-svg-icons/faTrash";
import {faDollarSign} from "@fortawesome/free-solid-svg-icons/faDollarSign";
import {CurrencyAndDateSettings} from "PageBuilder/Dialogs/TemplateTabs/CurrencyAndDateSettings";
import {LicenseIsRequired} from "InternalShared/Dialog/LicenseIsRequired";
import {FieldPickerTextBox} from "PageBuilder/pagebuilder/Controls/FieldPickerTextBox/FieldPickerTextBox";
import {PrinterTab} from "PageBuilder/Dialogs/TemplateSettingsTab/PrinterTab";
import {faPrint} from "@fortawesome/free-solid-svg-icons/faPrint";


library.add(faCog);
library.add(faPalette);
library.add(faTrash);
library.add(faDollarSign);

@observer
export class TemplateSettings extends React.Component<TemplateSettingsProps, TemplateSettingsState> {
    static defaultProps: Partial<TemplateSettingsProps> = {};
    public TabsToOpen:IObservableValue<string>;
    public StyleManager:StyleClassManager;
    public OnDispose:()=>void=null;
    public media:any;
    constructor(props: TemplateSettingsProps) {
        super(props);
        this.TabsToOpen=observable.box('General');
        this.StyleManager=new StyleManager().CreateStyleClassManager('.pdfBody');

        if(props.Options!=null&& props.Options.DocumentSettings.FileName!='')
        {
            props.Options.DocumentSettings.FormattedFileName={
                document: {
                    nodes: [
                        {
                            object: 'block',
                            type: 'paragraph',
                            nodes: [
                                {
                                    object: 'text',
                                    leaves: [
                                        {
                                            text: props.Options.DocumentSettings.FileName,
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            };

            props.Options.DocumentSettings.FileName='';
        }

        this.state = {
            IsOpen:true,
            PageType:props.Options.DocumentSettings.PageType,
            Orientation:props.Options.DocumentSettings.Orientation,
            HideFooter:props.Options.DocumentSettings.HideFooter,
            HideHeader:props.Options.DocumentSettings.HideHeader,
            EnableMultiplePage:props.Options.DocumentSettings.EnableMultiplePage,
            DefaultFontFamily:this.StyleManager.GetValue('font-family'),
            BackgroundColor:this.StyleManager.GetValue('background-color'),
            BackgroundImageId:props.Options.DocumentSettings.BackgroundImageId,
            BackgroundImageURL:props.Options.DocumentSettings.BackgroundImageURL,
            BackgroundStyle:props.Options.DocumentSettings.BackgroundStyle,
            Notifications:props.Options.DocumentSettings.Notifications
        };
    }

    private OnApply() {
        this.setState({
            IsOpen:false
        });

        this.StyleManager.SetValue('background-color',this.state.BackgroundColor);

        this.props.Options.DocumentSettings.HideFooter=this.state.HideFooter;
        this.props.Options.DocumentSettings.HideHeader=this.state.HideHeader;
        this.props.Options.DocumentSettings.EnableMultiplePage=this.state.EnableMultiplePage;
        this.props.Options.DocumentSettings.BackgroundStyle=this.state.BackgroundStyle;

        this.props.Options.DocumentSettings.BackgroundImageURL=this.state.BackgroundImageURL;
        this.props.Options.DocumentSettings.BackgroundImageId=this.state.BackgroundImageId;
        this.props.Options.DocumentSettings.Notifications=this.state.Notifications;

        if(this.state.PageType!=this.props.Options.DocumentSettings.PageType||this.state.Orientation!=this.props.Options.DocumentSettings.Orientation)
        {
            let newPage=PageService.AvailablePaperSizes.find(x=>x.type==this.state.PageType);
            this.props.Page.ChangePageSize({
                height:newPage.height,
                width:newPage.width,
                type:newPage.type
            },this.state.Orientation)
        }else{
            this.props.Page.AfterTemplateSettingsChanged();
        }

    }

    public render() {
        return (
            <Dialog AfterOnClose={()=>this.OnDispose()} OnApply={()=>{this.OnApply()}} IsOpen={this.state.IsOpen} Styles={{maxWidth:800,width:700}} Title={'Template Settings'} Icon={<FontAwesomeIcon icon={"cog"}/>} EnableCancel={false} EnableApply={true} ApplyTitle={'Done'}>
                <Tabs TabToOpen={this.TabsToOpen} OccupyAvailableSpace={true}>
                    <Tabs.Item Id={'General'} Title={"General"}  Icon={<FontAwesomeIcon icon={"cog"}/>}  >

                        <FieldPickerTextBox label={'PDF File Name'} Content={this.props.Options.DocumentSettings}  PropertyName={'FormattedFileName'} Model={this.props.Page.Form} />
                        <SearchableSelect isMulti={true} Label={'Attach pdf to the following emails'} Value={this.state.Notifications} onChange={(x:any)=>this.AttachToPdfChange(x)}>
                            {this.props.Page.Form.Notifications.length>0&&this.props.Page.Form.Notifications.map((option,index)=>
                                <option value={option.Id} key={option.Id}>{option.Name!=''&&option.Name.trim()!=''?option.Name:'Email '+index}</option>
                            )}
                        </SearchableSelect>

                        <SearchableSelect Value={this.state.PageType} onChange={e=>this.setState({PageType:e as any})} Label={"Page Type"}>
                            {PageService.AvailablePaperSizes.map(x=>
                                <option key={x.type} value={x.type}>{x.type}</option>
                            )}
                        </SearchableSelect>
                        <SearchableSelect Value={this.state.Orientation} onChange={e=>this.setState({Orientation:e as any})} Label={"Orientation"}>
                            <option value={"portrait"}>Portrait</option>
                            <option value={"landscape"}>Landscape</option>
                        </SearchableSelect>
                        <div style={{display:'flex'}}>

                            <RNCheckBox Label={'Hide header'} Value={this.state.HideHeader} onChange={e=>this.setState({HideHeader:e as any})} />
                            <RNCheckBox style={{marginLeft:10}} Label={'Hide footer'} Value={this.state.HideFooter} onChange={e=>this.setState({HideFooter:e as any})} />
                        </div>
                        <div>
                            <RNCheckBox Label={'Enable Multiple Page'} Value={this.state.EnableMultiplePage} onChange={e=>this.setState({EnableMultiplePage:e as any})} />
                        </div>
                    </Tabs.Item>
                    {rednaoVar.IsPr=="1" &&
                    <Tabs.Item Id={'Appearance'} Title={'Appearance'} Icon={<FontAwesomeIcon icon={"palette"}/>}>
                        <SearchableSelect Value={this.StyleManager.GetValue('font-family')}
                                          onChange={e =>this.ChangeFont(e)}
                                          Label={'Default Font Family'}>
                            <option value={''}>Default</option>
                            {rednaoVar.AvailableFonts.map(x =>
                                <option key={x} value={x}>{x}</option>
                            )}

                            <option value={'$add_new'}>Add Font</option>
                        </SearchableSelect>
                        <RNColor  Value={this.state.BackgroundColor}
                                  onChange={e => this.setState({BackgroundColor: e})}
                                  Label={'Background Color'}/>
                        <div className={'rncontrol'}>
                            <label>Background Image</label>

                            {this.state.BackgroundImageURL == '' ?
                                <div onClick={() => this.Click()} style={{
                                    width: 100,
                                    height: 100,
                                    border: '1px solid #dfdfdf',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    cursor:'pointer'
                                }}>
                                    <h4>Click here to select an image</h4>
                                </div> :
                                <div>
                                    <div style={{width:'100%',border: '1px solid #dfdfdf',cursor:"pointer",padding:5}} >
                                        <img src={this.state.BackgroundImageURL} style={{width: 100,height:100, border:'1px solid #dfdfdf'}} onClick={() => this.Click()}/>
                                        <SearchableSelect Value={this.state.BackgroundStyle.toString()} onChange={e=>this.setState({BackgroundStyle:e as any},()=>this.UpdateBackground())} Label={'Background Position'} style={{marginTop:5}}>
                                            <option value={'fill'} key={'fill'}>Fill</option>
                                            <option value={'repeat'} key={'repeat'}>Repeat</option>
                                            <option value={'top'} key={'top'}>Top</option>
                                            <option value={'left'} key={'left'}>Left</option>
                                            <option value={'right'} key={'right'}>Right</option>
                                            <option value={'bottom'} key={'bottom'}>Bottom</option>
                                            <option value={'center'} key={'center'}>Center</option>
                                        </SearchableSelect>
                                        <button onClick={()=>{
                                            this.setState({BackgroundImageId:'',BackgroundImageURL:'',BackgroundStyle:BackgroundStyleEnum.fill},()=>this.UpdateBackground())}}
                                          className={'rnbtn rnbtn-danger'}><FontAwesomeIcon icon={'trash'}/> Remove Image</button>
                                    </div>

                                </div>
                            }
                        </div>
                    </Tabs.Item>
                    }
                    <Tabs.Item Id={'Currency'} Title={'Currency Settings'} Icon={<FontAwesomeIcon icon={"dollar-sign"}/>}>
                        <CurrencyAndDateSettings Options={this.props.Page.PageOptions}/>
                    </Tabs.Item>

                    {rednaoVar.IsPr&&
                        <Tabs.Item Id={'Printer'} Title={'Printer'} Icon={<FontAwesomeIcon icon={faPrint}/>}>
                            <PrinterTab DocumentOptions={this.props.Options}/>
                        </Tabs.Item>
                    }
                </Tabs>
            </Dialog>
        )
    }


    private async ChangeFont(font: string) {
        if(font=='$add_new')
        {
            font=await Dialog.Show(<FontUploader/>);
            if(font==''||font==null) {
                return;
            }
        }

        this.StyleManager.SetValue('font-family',font);
        this.forceUpdate();
    }

    private Click() {
        if(this.media==null)
        {
            this.media = (window as any).wp.media({
                title: "Which image do you want to use in your pdf?",
                multiple: false,
                button: {
                    text: 'Select an image'
                }
            });




            this.media.on('select',  ()=> {
                let selection = this.media.state().get('selection');
                if (selection == null)
                    return;

                selection.each((attachment) =>{
                    let url=attachment.attributes.url;
                    let urlid=attachment.attributes.id;
                    this.setState({
                        BackgroundImageURL:url,
                        BackgroundImageId:urlid
                    },()=>    this.UpdateBackground());

                });

            });
        }

        this.media.open();
    }

    private UpdateBackground() {

        this.props.Options.DocumentSettings.BackgroundImageURL=this.state.BackgroundImageURL;
        this.props.Options.DocumentSettings.BackgroundImageId=this.state.BackgroundImageId;
        this.props.Options.DocumentSettings.BackgroundStyle=this.state.BackgroundStyle;
        this.props.Page.UpdateBackground();
    }

    private AttachToPdfChange(x: any) {
        if(rednaoVar.IsPr=='')
        {
            Dialog.Show(<LicenseIsRequired Message={'Sorry this feature is only available in the full version, the free version attach the pdf to all the emails'}/>);
            return;
        }
        this.setState({Notifications:x.map(y=>y.value) as any});
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface TemplateSettingsProps {
    Options:PDFDocumentOptions;
    Page:PDFDocument;
}

interface TemplateSettingsState {
    IsOpen:boolean;
    PageType:PageTypeEnum;
    Orientation:"portrait"|"landscape";
    HideFooter:boolean;
    EnableMultiplePage:boolean;
    HideHeader:boolean;
    DefaultFontFamily:string;
    BackgroundColor:string;
    BackgroundImageId:string;
    BackgroundImageURL:string;
    BackgroundStyle:BackgroundStyleEnum;
    Notifications:any[];
}



//#endregion "My Region"